import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SqlService } from 'src/app/Database/sql.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-view-audit-log',
  templateUrl: './view-audit-log.component.html',
  styleUrls: ['./view-audit-log.component.css']
})
export class ViewAuditLogComponent implements OnInit {

  closeResult = '';
  DisplayErrormessage = "";
  PopupTitle = "";


  SearchValue = {
    Boxno: ""
  };

  data = [
    {
      Boxno: "",
      DeletedBy: "",
      DeletedDate: ""
    }
  ];

  p: number = 1;
  ItemsPerPage = 20;

  Amount = 0;

  iRowsLoaded = 0;

  constructor(private dbService: SqlService, private router: Router, private modalService: NgbModal, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.clearData();
  }

  clearData() {
    this.iRowsLoaded = 0;
    this.data = [];

    this.getData();
  }

  LoadMoreFields() {
    this.getData();
  }

  getData() {
    Swal.fire({
      title: 'Loading Boxes.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    var formData = new FormData(); // Currently empty 

    var SQLQuery = "";

    if (this.SearchValue.Boxno != "") {
      SQLQuery += " AND AuditLog.TableKey like '%" + this.SearchValue.Boxno + "%' ";
    }

    formData.set("SQLQuery", SQLQuery);
    formData.set("start", (this.iRowsLoaded).toString());
    this.iRowsLoaded += 200;
    formData.set("end", (this.iRowsLoaded).toString());

    this.dbService.getAuditLog(formData).subscribe((ret: any) => {
      if (ret != "false") {
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          let elementtemp = element.split(",")
          // $row['']  ."," . $row['']  ."," . $row[''].";";

          let temp = {
            Boxno: elementtemp[0],
            DeletedBy: elementtemp[1],
            DeletedDate: elementtemp[2]
          };

          this.data.push(temp);
        });
        Swal.close();
      } else {
        this.PopupTitle = "Something went wrong while loading boxes."
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    });

  }

  ViewData(AreaID: string) {
    this.router.navigate(['/ViewSpecificBox', AreaID]);
  }

  ClearSearch() {
    this.SearchValue = {
      Boxno: ""
    };

    this.clearData();
    this.getData();
  }

  ClearBoxNoSearch() {
    this.SearchValue.Boxno = "";
    this.Search();
  }

  Search() {
    Swal.fire({
      title: 'Searching for box.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });
    this.clearData();
    this.getData();
  }

  async btnDownloadReportClickExcel() {
    var formData = new FormData(); // Currently empty 

    var SQLQuery = "";


    if (this.SearchValue.Boxno != "") {
      SQLQuery += " AND AuditLog.TableKey like '%~" + this.SearchValue.Boxno + "%' ";
    }

    var formData = new FormData();
    formData.set("SQLQuery", SQLQuery);

    let Link = '';
    if(this.document.location.hostname.includes('admin.pactel.co.za')){
      Link = "https://admin.pactel.co.za/xdt/assets/php/";
    }else{
      Link = 'http://10.10.10.2/xdt/assets/php/';
    }
    //this.http.post(this.Link + 'getAllClientsForView.php',frmData);
    window.open(Link + "exportAuditLog.php?SQLQuery=" + SQLQuery);
    //this.dbService.ExportAllDirectBoxes(formData)
  }//https://github.com/mk-j/PHP_XLSXWriter




  open(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = 'Closed with: ${result}';
      }, (reason) => {
        this.closeResult =
          'Dismissed ${this.getDismissReason(reason)}';
        //let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        //element.click();
      });
  }

}
